package com.xtream.composeapp.presentation.ui.tvchannels

import androidx.compose.foundation.focusGroup
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.PaddingValues
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.lazy.LazyColumn
import androidx.compose.foundation.lazy.itemsIndexed
import androidx.compose.foundation.lazy.rememberLazyListState
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.filled.Visibility
import androidx.compose.material.icons.filled.VisibilityOff
import androidx.compose.material3.ExperimentalMaterial3Api
import androidx.compose.material3.Icon
import androidx.compose.material3.IconButtonDefaults
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Scaffold
import androidx.compose.material3.Text
import androidx.compose.material3.TopAppBar
import androidx.compose.material3.TopAppBarDefaults
import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.ui.Modifier
import androidx.compose.ui.focus.FocusRequester
import androidx.compose.ui.focus.focusRequester
import androidx.compose.ui.platform.LocalDensity
import androidx.compose.ui.platform.LocalWindowInfo
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.unit.dp
import androidx.lifecycle.compose.collectAsStateWithLifecycle
import com.xtream.composeapp.viewmodel.SeriesViewModel
import com.xtream.composeapp.viewmodel.VodStreamsViewModel
import com.xtream.composeapp.viewmodel.livetv.StreamControlViewModel
import com.xtream.data_kmp.db.tables.CategoryWithVisibleStatus
import com.xtream.data_kmp.db.tables.StreamType
import com.xtream.data_kmp.dto.CategoryBase
import com.xtream.data_kmp.dto.LiveCategory
import com.xtream.data_kmp.dto.SeriesCategory
import com.xtream.data_kmp.dto.VodCategory
import com.xtream.sharedResources.resources.Res
import com.xtream.sharedResources.resources.categories
import com.xtream.ui.ui.widget.FocusPositioner
import com.xtream.ui.ui.widget.NavigationButton
import com.xtream.ui.ui.widget.TvButton
import org.jetbrains.compose.resources.stringResource
import org.koin.compose.viewmodel.koinViewModel

@Composable
fun ManageCategoriesScreen(
    modifier: Modifier= Modifier,
    type: StreamType= StreamType.LIVE,
    title: String= stringResource(Res.string.categories),

    onNavigationIconClick: (() -> Unit)?=null,

    ) {


    Scaffold(
        modifier = modifier,
        topBar = {
            @OptIn(ExperimentalMaterial3Api::class)
            TopAppBar(
                colors = TopAppBarDefaults.topAppBarColors(
                    containerColor = MaterialTheme.colorScheme.background
                ),
                title = {
                    Text(
                        modifier = Modifier.fillMaxWidth(),
                        textAlign = TextAlign.Center,
                        text = title,
                        style = MaterialTheme.typography.titleLarge
                    )
                },
                navigationIcon = {
                    onNavigationIconClick.takeIf { it!=null }?.let {
                        NavigationButton(
                            onClick = it,
                            colors =  IconButtonDefaults.iconButtonColors(
                                contentColor = MaterialTheme.colorScheme.onBackground
                            )

                        )
                    }

                }

            )
        }
    ) { innerPadding ->
        val contentModifier = Modifier. padding(horizontal = 24.dp) .padding(PaddingValues(  top = innerPadding.calculateTopPadding() + 8.dp))

            when (type) {
            StreamType.LIVE -> ManageLiveCategories(contentModifier)
            StreamType.MOVIE -> ManageVodCategories(contentModifier)
            else -> ManageSeriesCategories(contentModifier)
        }
    }
}

@Composable
private fun ManageLiveCategories(
    modifier: Modifier= Modifier,
    onNavigationIconClick: (() -> Unit)?=null,

    ){
    val streamControlViewModel: StreamControlViewModel = koinViewModel()
    val tvChannelsWithStatus by streamControlViewModel.tvCategoriesWithVisibleStatus.collectAsStateWithLifecycle(emptyList())

    ShowHideTvCategoriesTvList(
    modifier=modifier,
        itemsWithStatus=tvChannelsWithStatus,
        onNavigationIconClick =onNavigationIconClick,

        onClick = {item->
            (item as? LiveCategory)?.let { category ->
                streamControlViewModel.toggleCategoryVisibility(category)
            }

        }

    )}



@Composable
private fun ManageVodCategories(
    modifier: Modifier= Modifier,
    onNavigationIconClick: (() -> Unit)?=null,

    ){
    val vodStreamsViewModel: VodStreamsViewModel = koinViewModel()
    val tvChannelsWithStatus by vodStreamsViewModel.vodCategoriesWithVisibleStatus.collectAsStateWithLifecycle(emptyList())

    ShowHideTvCategoriesTvList(
        modifier=modifier,
        itemsWithStatus=tvChannelsWithStatus,
        onNavigationIconClick =onNavigationIconClick,

        onClick = {item->
            (item as? VodCategory)?.let { category ->
                vodStreamsViewModel.toggleCategoryVisibility(category)
            }

        }

    )}

@Composable
private fun ManageSeriesCategories(
    modifier: Modifier= Modifier,
    onNavigationIconClick: (() -> Unit)?=null,

    ){
    val seriesViewModel: SeriesViewModel = koinViewModel()
    val tvChannelsWithStatus by seriesViewModel.categoriesWithVisibleStatus.collectAsStateWithLifecycle(emptyList())

    ShowHideTvCategoriesTvList(
        modifier=modifier,
        itemsWithStatus=tvChannelsWithStatus,
        onNavigationIconClick =onNavigationIconClick,

                onClick = {item->
            (item as? SeriesCategory)?.let { category ->
                seriesViewModel.toggleCategoryVisibility(category)
            }

        }

    )}

@Composable
fun ShowHideTvCategoriesTvList(
    modifier: Modifier = Modifier,
    itemsWithStatus: List<CategoryWithVisibleStatus<out CategoryBase>>,
    onNavigationIconClick: (() -> Unit)?=null,

    onClick: ( CategoryBase)-> Unit

) {

    val scope = rememberCoroutineScope()

    val listState = rememberLazyListState(0, 0)




        val containerFocusRequester = remember { FocusRequester() }

        FocusPositioner(
            parentFraction = 0.5f,
            childFraction = 0.5f,
        ) {
            val density = LocalDensity.current
            val screenHeightDp = with(density) {
                LocalWindowInfo.current.containerSize.height.toDp()
            }
            LazyColumn(
                state = listState,
                modifier = Modifier
                    .focusRequester(containerFocusRequester)
                    .focusGroup()
                    // Lambda form: evaluated fresh on each restore trigger,
                    // so it always points at the correct requester even after
                    // selectedCategory changes.
                 //   .focusRestorer(
                //        focusRequesters[restoreTargetKey]
                  //          ?: FocusRequester.Default
                  //  )
                    // IMPORTANT_UNCOMMENT_IN_NEXT_UPDATES
                    // .focusProperties {
                    //     onEnter = { if (isFullScreen) cancelFocusChange() }
                    // }
                    .fillMaxSize(),
                verticalArrangement = Arrangement.spacedBy(8.dp),
                contentPadding = PaddingValues(
                    bottom = screenHeightDp/2,
                    start = 4.dp, end = 4.dp
                )
            ) {
                itemsIndexed(
                    itemsWithStatus,
                    key = { index, item ->
                        "cat_${item.category.categoryId ?: item.category.categoryName ?: index}"
                    }
                ) { _, itm ->
                    val item = itm.category
                    val itemKey = item.categoryId ?: item.categoryName ?: ""
                    // Safe fallback: should never be needed since map is built
                    // from allItems, but guards against race during recomposition.
                 //   val itemFocusRequester = focusRequesters[itemKey]
                      //  ?: remember { FocusRequester() }

                    TvButton(
                        selected = false,
                        modifier = Modifier
                           // .focusRequester(itemFocusRequester)
                            ,
                        fillParent = true,
                        title = item.categoryName ?: "",
                        onClick = {
                            onClick(item)
                        },
                        trailingContent = {
                            Icon(
                                imageVector = if (itm.isHidden) {
                                    Icons.Default.VisibilityOff
                                } else {
                                    Icons.Default.Visibility
                                },
                                contentDescription = null
                            )

                        }

                    )
                }
            }
        }

}